<script>
import AdminLayout from '@layouts/admin-main'
import LoginlogList from '@components/admin/loginlog-list'
import MemberNav from '@components/admin/member-nav'

export default {
  page: {
    title: 'Admin::LoginlogList',
    meta: [{ name: 'description', content: 'Admin::LoginlogList' }],
  },
  components: { AdminLayout, LoginlogList, MemberNav },
}
</script>

<template>
  <AdminLayout>
    <MemberNav></MemberNav>
    <LoginlogList></LoginlogList>
  </AdminLayout>
</template>

<style lang="scss" module>
@import '@design';
</style>
